import { render, staticRenderFns } from "./CssVariables.vue?vue&type=template&id=4c044c98&scoped=true"
import script from "./CssVariables.vue?vue&type=script&lang=js"
export * from "./CssVariables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c044c98",
  null
  
)

export default component.exports